// extracted by mini-css-extract-plugin
module.exports = {"productHuntBadge":"Layout-module--product-hunt-badge--12FIL","productHuntBadge__image":"Layout-module--product-hunt-badge__image--2F7pk"};